<template>
  <div class="goods_class" id="goodsClassBox"  :style="boxStyle">
    <template v-if="detailData.goodsList.length">
      <el-scrollbar class="left_tab_box" style="max-height: 100%;">
          <div v-for="(item,index) in detailData.goodsList" :key="index" :class="item.hover?'hover item':'item'">{{item.name}}</div>
      </el-scrollbar>
      <el-scrollbar class="right_tab_box" style="max-height: 100%;">
        <div v-for="(item,index) in detailData.goodsList" :key="index">
            <div class="title">{{item.name}}</div>
            <div class="list_box">
              <mallItemPerson
                  :initFlag="false"
                  :list="item.goodsList"
                  :allShowVerFlag='false' >
              </mallItemPerson>
            </div>
        </div>
      </el-scrollbar>
    </template>
    <div v-else class="defaultImg"></div>
  </div>
</template>

<script>
import mixins from '../mixins/mixins'
import mallItemPerson from './mallItemPerson.vue'
export default {
  name: 'goodsClass',
  mixins: [mixins],
  props: {
  },
  components: {
    mallItemPerson
  },
  data() {
    return {
      detailData: {
        goodsList: []
      },
      pattern: {},
    }
  },
  watch: {
  },
  computed: {
    boxStyle(){
      return {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
        "height": this.detailData.goodsList.length?"330px":"auto"
      }
    },
  },
  methods: {
    async init() {
      this.detailData = {
        goodsList: []
      }
      this.$nextTick(async () => {
        this.detailData = await this._filter(this.itemData)
        this.pattern = this.detailData.pattern || {}
        console.log("goodsClass----------this.detailData");
        console.log(this.detailData);
      })
      
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
    .goods_class{
      background: #FFFFFF;
      padding: 10px 0;
      border-radius: 6px;
      .left_tab_box{
        width: 100px;
        height: 100%;
        display: inline-block;
        vertical-align: top;
        border-right: 1px solid #eee;
        .item{
          width: 60px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          color: #333;
          border-radius: 13px;
          margin: 0 auto;
          margin-bottom: 23px;
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &.hover{
            background: #eb637a;
            color: #fff;
          }
        }
      }
      .right_tab_box{
        width: calc(100% - 110px);
        height: 100%;
        margin-left: 10px;
        display: inline-block;
        .title{
          font-weight: 400;
          font-size: 12px;
          color: #909090;
          padding-bottom: 8px;
          padding-top: 3px;
          border-bottom: 1px solid #E9E9E9;
          margin-bottom: 10px;
        }
        .list_box{
        }
      }
      .defaultImg{
          width: 100%;
          height: 0;
          padding-top: 37.6%;
          background-image: url("../image/goodsClass.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
      }
    }
</style>
